// extracted by mini-css-extract-plugin
export default {"footerLink":"footer_footerLink__fg+Yh","footer_block":"footer_footer_block__gsjWA","footerForm":"footer_footerForm__AkMRl","formTitle":"footer_formTitle__IHMPR"};